import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnnouncer } from './Announcer';

/**
 * Sets document.title to "<part> – <part> – Evidencia inšpekcií" and announces the new page to screen readers.
 * Example: ['Krok 2 z 4', 'Inšpekčný tím', 'Nová inšpekcia'].
 */
export function usePageTitle(parts: (string | null | undefined | false)[]): void {
  const { t } = useTranslation();
  const { announce } = useAnnouncer();
  const title = [...parts.filter(Boolean), t('app.name')].join(' – ');
  useEffect(() => {
    if (document.title !== title) {
      document.title = title;
      announce(t('layout.pageChanged', { title }));
    }
  }, [title, announce, t]);
}
